// This function is used to sort the project numbers in the correct order by splitting the project number into its components and padding the middle component with zeros if it is less than 3 characters long.
// This fixes sorting issues caused by client numbers greater than 99
// This would need to be refactored when client numbers react 1000
export const projNumSort = (sortOrder, header, list) => {
    const digitCount = 3
    if (sortOrder === 'asc') {
        list.sort((a,b) => (
            (a[header].split('.')[1].length<digitCount? [a[header].split('.')[0], a[header].split('.')[1].padStart(3, '0'), a[header].split('.')[2]].join(".") : a[header])
            >
            (b[header].split('.')[1].length<digitCount? [b[header].split('.')[0], b[header].split('.')[1].padStart(3, '0'), b[header].split('.')[2]].join(".") : b[header])
            ? 1 : -1
        ))
    } else {
        list.sort((a,b) => (
            (a[header].split('.')[1].length<digitCount? [a[header].split('.')[0], a[header].split('.')[1].padStart(3, '0'), a[header].split('.')[2]].join(".") : a[header])
            <
            (b[header].split('.')[1].length<digitCount? [b[header].split('.')[0], b[header].split('.')[1].padStart(3, '0'), b[header].split('.')[2]].join(".") : b[header])
            ? 1 : -1
        ))
    }
    return list
}

export const dateSort = (sortOrder, header, list) => {
    if (sortOrder === 'asc') {
        list.sort((a,b) => (
            (a[header]? new Date(a[header]) : new Date('1900-01-01'))
            >
            (b[header]? new Date(b[header]) : new Date('1900-01-01'))
            ? 1 : -1
        ))
    } else {
        list.sort((a,b) => (
            (a[header]? new Date(a[header]) : new Date('1900-01-01'))
            <
            (b[header]? new Date(b[header]) : new Date('1900-01-01'))
            ? 1 : -1
        ))
    }
    return list
}